import {ReactKeycloakProvider} from "@react-keycloak/web";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import keycloak from "./keycloak";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './i18n';

const tokenLogger = (tokens) => {
    localStorage.setItem("token", tokens.token);
    localStorage.setItem("id_token", tokens.idToken);
};

const eventHandler = (event) => {
    if (event == "onAuthSuccess") {
        localStorage.setItem("token", keycloak.token);
        localStorage.setItem("id_token", keycloak.idToken);
    }
};
const REDIRECT_URI = `${window.location.origin}/`;

ReactDOM.render(
    <ReactKeycloakProvider
        authClient={keycloak}
            initOptions={{
                onLoad: "login-required",
                checkLoginIframe: false,
                redirectUri: REDIRECT_URI,
                useNonce: false,
            }}
            onTokens={tokenLogger}
            onEvent={eventHandler}
        >
            <App />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </ReactKeycloakProvider>,
    document.getElementById("root")
);